/* eslint-disable */
const hash = {
  "en-US": "52f2b85c",
  "de-DE": "f73b6d29",
  "es-ES": "c8c92d4d",
  "fr-FR": "0c6288d1",
  "id-ID": "0e01b3b7",
  "it-IT": "b310bf73",
  "jp-JP": "b1af9766",
  "ko-KO": "add96452",
  "nl-NL": "a2ede68f",
  "pl-PL": "22f3d891",
  "pt-PT": "6e42c676",
  "ru-RU": "64d656ad",
  "tr-TR": "d99454dc",
  "vi-VN": "7f570ec6",
  "zh-CN": "aba751b2",
  "zh-TW": "f83f1150",
  "sv-SE": "cfa5bec8",
  "control": "09f3cfda",
  "plan-details": "ed85eac3",
  "gov-EN": "880dc6cb",
  "en-GB": "b33aa09e"
}
export default hash
